// src/components/admin/page-sections/FeaturesSection.js
import React from 'react';

const FeaturesSection = ({ content }) => {
  const {
    title = 'Why Choose Bag & Box?',
    subtitle = 'We combine quality, innovation, and sustainability to deliver the perfect packaging solution for your brand.',
    features = [
      {
        icon: 'star',
        title: 'Premium Quality',
        description: 'All our products are crafted with premium materials for exceptional durability and presentation.'
      },
      {
        icon: 'leaf',
        title: 'Eco-Friendly',
        description: 'We prioritize sustainable materials and manufacturing processes to minimize environmental impact.'
      },
      {
        icon: 'award',
        title: 'Custom Designs',
        description: 'Our design team works with you to create unique packaging that perfectly represents your brand.'
      },
      {
        icon: 'truck',
        title: 'Fast Delivery',
        description: 'With our efficient production and shipping, your orders will arrive right when you need them.'
      }
    ],
    backgroundColor = '#ffffff',
    titleColor = '#111827',
    subtitleColor = '#4b5563',
    featureTitleColor = '#1f2937',
    featureDescriptionColor = '#6b7280',
    iconColor = '#3b82f6',
    iconBackgroundColor = '#e0f2fe',
    borderEnabled = true,
    borderColor = '#e5e7eb',
    cardShadow = true,
    cardBackgroundColor = '#ffffff',
    cardBorderRadius = '0.75rem',
    columnsPerRow = {
      mobile: 1,
      tablet: 2,
      desktop: 4
    },
    paddingTop = '5rem',
    paddingBottom = '5rem',
    marginBottom = '2rem',
    animationEnabled = true,
    showDivider = true,
    dividerColor = '#3b82f6',
    alignCenter = true,
    iconSize = 'large'
  } = content || {};

  // Function to render the right icon based on name
  const renderIcon = (iconName, size = 32) => {
    switch (iconName) {
      case 'star':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
          </svg>
        );
      case 'leaf':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3"></path>
            <path d="M16 16a4 4 0 0 1-4 4"></path>
          </svg>
        );
      case 'award':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="8" r="7"></circle>
            <polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88"></polyline>
          </svg>
        );
      case 'truck':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <rect x="1" y="3" width="15" height="13"></rect>
            <polygon points="16 8 20 8 23 11 23 16 16 16 16 8"></polygon>
            <circle cx="5.5" cy="18.5" r="2.5"></circle>
            <circle cx="18.5" cy="18.5" r="2.5"></circle>
          </svg>
        );
      case 'shield':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
          </svg>
        );
      case 'globe':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="2" y1="12" x2="22" y2="12"></line>
            <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
          </svg>
        );
      case 'clock':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10"></circle>
            <polyline points="12,6 12,12 16,14"></polyline>
          </svg>
        );
      case 'heart':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
          </svg>
        );
        case 'no icon':
          return (
            <span>
              {/* No icon to display */}
            </span>
          );;
      default:
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="12" y1="8" x2="12" y2="16"></line>
            <line x1="8" y1="12" x2="16" y2="12"></line>
          </svg>
        );
    }
  };

  // Determine column classes based on columnsPerRow setting
  const getColumnClasses = () => {
    const { mobile, tablet, desktop } = columnsPerRow;
    let classes = 'grid gap-6 ';

    // Mobile first
    classes += `grid-cols-${mobile || 1} `;
    // Tablet breakpoint (md)
    if (tablet) classes += `md:grid-cols-${tablet} `;
    // Desktop breakpoint (lg)
    if (desktop) classes += `lg:grid-cols-${desktop}`;

    return classes;
  };

  return (
    <div style={{
      backgroundColor,
      paddingTop,
      paddingBottom,
      marginBottom
    }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section header */}
        {(title || subtitle) && (
          <div className={`text-center ${showDivider ? 'mb-12' : 'mb-8'}`}>
            {title && (
              <h2
                className="text-3xl font-bold tracking-tight sm:text-4xl"
                style={{ color: titleColor }}
              >
                {title}
              </h2>
            )}

            {subtitle && (
              <p
                className="mt-3 max-w-2xl mx-auto text-xl"
                style={{ color: subtitleColor }}
              >
                {subtitle}
              </p>
            )}

            {showDivider && (
              <div
                className="mt-6 mx-auto w-24 h-1 rounded"
                style={{ backgroundColor: dividerColor }}
              ></div>
            )}
          </div>
        )}

        {/* Features grid */}
        <div className={getColumnClasses()}>
          {features && features.map((feature, index) => {
            // Individual feature styling with fallbacks to global settings
            const itemBackgroundColor = feature.backgroundColor || cardBackgroundColor;
            const itemBorderColor = feature.borderColor || borderColor;
            const itemBorderWidth = feature.borderWidth || '1px';
            const itemBorderStyle = feature.borderStyle || 'solid';
            const itemBorderRadius = feature.borderRadius || cardBorderRadius;
            const itemPadding = feature.padding || '1.5rem';
            const itemMargin = feature.margin || '0';
            const itemTextAlign = feature.textAlign || (alignCenter ? 'center' : 'left');
            const itemTitleColor = feature.titleColor || featureTitleColor;
            const itemDescColor = feature.descriptionColor || featureDescriptionColor;
            const itemIconColor = feature.iconColor || iconColor;
            const itemIconBgColor = feature.iconBackgroundColor || iconBackgroundColor;
            const itemIconSize = feature.iconSize || iconSize;
            const itemTitleFontSize = feature.titleFontSize || '1.25rem';
            const itemDescFontSize = feature.descriptionFontSize || '1rem';
            const itemTitleFontWeight = feature.titleFontWeight || 'medium';
            const itemDescFontWeight = feature.descriptionFontWeight || 'normal';

            // Get icon size number
            const getIconSize = (size) => {
              switch (size) {
                case 'small': return 16;
                case 'medium': return 24;
                case 'large': return 32;
                case 'extra-large': return 40;
                default: return 32;
              }
            };

            // Box shadow logic
            const getBoxShadow = () => {
              if (feature.boxShadow === false) return 'none';
              if (feature.customShadow) return feature.customShadow;
              if (cardShadow) return '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)';
              return 'none';
            };

            // Hover transform logic
            const getHoverTransform = (transformType) => {
              switch (transformType) {
                case 'scale': return 'scale(1.05)';
                case 'translateY': return 'translateY(-4px)';
                case 'rotate': return 'rotate(2deg)';
                default: return 'none';
              }
            };

            // Font weight mapping
            const getFontWeight = (weight) => {
              const weights = {
                'light': '300',
                'normal': '400',
                'medium': '500',
                'semibold': '600',
                'bold': '700'
              };
              return weights[weight] || weights.normal;
            };

            return (
              <div
                key={index}
                className="transition-all duration-300 ease-out cursor-pointer"
                style={{
                  backgroundColor: itemBackgroundColor,
                  borderRadius: itemBorderRadius,
                  border: borderEnabled ? `${itemBorderWidth} ${itemBorderStyle} ${itemBorderColor}` : 'none',
                  boxShadow: getBoxShadow(),
                  margin: itemMargin,
                  textAlign: itemTextAlign
                }}
                onMouseEnter={(e) => {
                  if (feature.hoverEffect !== false) {
                    e.currentTarget.style.backgroundColor = feature.hoverBackgroundColor || '#f3f4f6';
                    e.currentTarget.style.transform = getHoverTransform(feature.hoverTransform || 'scale');
                  }
                }}
                onMouseLeave={(e) => {
                  if (feature.hoverEffect !== false) {
                    e.currentTarget.style.backgroundColor = itemBackgroundColor;
                    e.currentTarget.style.transform = 'none';
                  }
                }}
              >
                <div style={{ padding: itemPadding }}>
                  {feature.icon && feature.icon !== 'no icon' &&  (
                    <div
                      className={`${itemTextAlign === 'center' ? 'mx-auto' : itemTextAlign === 'right' ? 'ml-auto' : ''} flex items-center justify-center rounded-full mb-4`}
                      style={{
                        backgroundColor: itemIconBgColor,
                        color: itemIconColor,
                        width: `${getIconSize(itemIconSize) + 16}px`,
                        height: `${getIconSize(itemIconSize) + 16}px`
                      }}
                    >
                      
                      {renderIcon(feature.icon, getIconSize(itemIconSize))}
                    </div>
                  )}

                  {feature.title && (
                    <h3
                      className="mb-2"
                      style={{
                        color: itemTitleColor,
                        fontSize: itemTitleFontSize,
                        fontWeight: getFontWeight(itemTitleFontWeight)
                      }}
                    >
                      {feature.title}
                    </h3>
                  )}

                  {feature.description && (
                    <p
                      style={{
                        color: itemDescColor,
                        fontSize: itemDescFontSize,
                        fontWeight: getFontWeight(itemDescFontWeight)
                      }}
                    >
                      {feature.description}
                    </p>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default FeaturesSection;